<template>
  <BaseModal
    :heading="
      $t('global.actions.email_item', { item: $t('global.items.document') })
    "
    small
    useForm
    @submit="send"
    :parentRoute="{
      name: parentRouteName
    }"
    :loading="loading"
  >
    <Form
      v-model:emailAddress="emailAddress"
      v-model:emailSubject="emailSubject"
      v-model:editorContent="editorContent"
    />
    <template #footer>
      <BaseButton
        :loading="isSaving"
        submitForm
        v-test="'document-email-save'"
      >
        {{ $t('global.actions.send') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  lang="ts"
  setup
>
import { useMutation, useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { flash } from '@/helpers/ui';
import { segment } from '@/segment';
import Form from './Form.vue';

const props = defineProps<{
  parentRouteName: string;
}>();

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const documentId = route.params.documentId;
const orderId = route.params.orderId;

const emailAddress = ref('');
const emailSubject = ref('');
const editorContent = ref('');
const isSaving = ref(false);

const { loading, onResult } = useQuery(
  gql`
    query getOrder($id: ID!) {
      order(id: $id) {
        id
        invoiceEmailSubjectTemplate
        customer {
          email
        }
      }
    }
  `,
  { id: orderId },
  { enabled: !!orderId },
);

onResult(({ data: { order } }: any) => {
  emailAddress.value = order.customer?.email || '';
  emailSubject.value = order.invoiceEmailSubjectTemplate;
});

const { mutate: sendSaleDocument } = useMutation(gql`
  mutation sendSaleDocument($input: SendSaleDocumentInput!) {
    sendSaleDocument(input: $input) {
      errors
    }
  }
`);

const send = () => {
  isSaving.value = true;

  sendSaleDocument({
    input: {
      customMessage: editorContent.value,
      customSubject: emailSubject.value,
      documentId,
      email: emailAddress.value,
    },
  })
    ?.then(() => {
      router.push({ name: 'sale', params: { id: orderId } });
      flash(t('global.flash.email_sent'));
    })
    .finally(() => {
      segment.track('register.sales.sale_documents.send_document.confirmed');
      isSaving.value = false;
    });
};
</script>
